import { NativeBridgeResponse } from 'scbk-services/types/bridge/global';
import { useNativeBridgeWithCallback } from './useNativeBridge';

export namespace Keypad {
    /**
     * 네이티브 보안키패드
     */
    export interface EncKeypadRequest {
        id: string;
        type: string; // 0:숫자 1:문자
        serverKey: string;
        maxlength: string;
        aesEnc: string; //0: enc 1: aesEnc,2: usim pin 기본은 0이고, 1은 aesEnc : 솔루션 연동 값인경우 1로 셋팅 (예:인증서 암호 등 연동)
    }

    export interface EncKeypadResponse {
        result: string; // -1:취소, 0:완료, 1:진행중
        dummyData: string;
        encData: string; //암호화 데이터,
        enc2Data: string;
        aesEnc: string;
    }
}

/**
 * 보안키패드 네이티브 브릿지 hook
 * @returns
 */
export const useKeypadBridge = () => {
    const nativeBridgeWithCallback = useNativeBridgeWithCallback();

    /**
     * 네이티브 보안키패드
     * @param request
     * @returns
     */
    const doNEncKeyPad = async (
        request: Keypad.EncKeypadRequest,
        callback: (response: NativeBridgeResponse<Keypad.EncKeypadResponse>) => void,
    ) => {
        nativeBridgeWithCallback<Keypad.EncKeypadRequest, Keypad.EncKeypadResponse>(
            'doNEncKeyPad',
            request,
            {
                callback: {
                    once: false,
                    fn: (response: NativeBridgeResponse<Keypad.EncKeypadResponse>) => {
                        if (callback) {
                            callback(response);
                        }
                    },
                },
            },
        );
    };

    return {
        doNEncKeyPad,
    };
};
